import { useMemo } from "react";
import { useAccountsData } from "./useAccountsData";
import { useParsedAccountsData } from "./useParsedAccountsData";
export const useAccountData = (key) => {
    const theKey = useMemo(() => [key], [key]);
    const [data] = useAccountsData(theKey);
    return {
        loading: key !== undefined && data === undefined,
        data,
    };
};
/**
 * Loads the parsed data of a single account.
 * @returns
 */
export const useParsedAccountData = (key, parser) => {
    const theKey = useMemo(() => [key], [key]);
    const [data] = useParsedAccountsData(theKey, parser);
    return {
        loading: key !== undefined && data === undefined,
        data,
    };
};
//# sourceMappingURL=useAccountData.js.map